import { Component, effect, inject, signal, WritableSignal } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

import { SessionService } from '../../services/session.service';

import { DialogData } from '../../interfaces/dialog-data';
import { FieldDescription } from '../../interfaces/field-description';

@Component({
  selector: 'app-dialog-handler',
  template: '',
  standalone: false
})
export class DialogHandlerComponent {
  public dialogRef = inject(DialogRef<DialogData>);
  public data: DialogData = inject(DIALOG_DATA);

  public session = inject(SessionService);

  structureName: WritableSignal<string> = signal(undefined);
  importedRowFieldStructure: WritableSignal<FieldDescription[][]> = signal(undefined);

  rowDataDefault: WritableSignal<FieldDescription[][]> = signal(undefined);

  constructor () {
    effect(() => {
      if (!this.structureName() || !this.importedRowFieldStructure()) {
        return;
      }
      this.rowDataDefault.set(this.importedRowFieldStructure());
    });
  };

  close() {
    this.dialogRef.close(null);
  };

  save() {
    this.dialogRef.close(this.data);
  };

  signalAction(action: string) {
    if (action === 'save') {
      this.save();
    }
    else if (action === 'cancel') {
      this.close();
    }
  };
};
